export const formatYoutubeVideo = (url: string) => {
  if (url.includes("watch")) {
    return url.replace("watch?v=", "embed/");
  } else if (url.includes(".be")) {
    return url.replace(".be/", "be.com/embed/");
  }
  return url;
};
